import request from '@/utils/request'

export function getGoodsComponentList(data) {
  return request.post('/goods-component/list', data)
}

export function modifyGoodsComponent(data) {
  return request.post('/goods-component/modify', data)
}

export function deleteGoodsComponent(data) {
  return request.post('/goods-component/delete', data)
}

export function getGoodsTypeList() {
  return request.post('/goods-type/list')
}

export function addGoodsType(data) {
  return request.post('/goods-type/add', data)
}

export function modifyGoodsType(data) {
  return request.post('/goods-type/modify', data)
}

export function deleteGoodsType(data) {
  return request.post('/goods-type/delete', data)
}

export function getGoodsList(data) {
  return request.post('/goods/list', data)
}

export function addGoods(data) {
  return request.post('/goods/add', data)
}

export function modifyGoods(data) {
  return request.post('/goods/modify', data)
}

export function deleteGoods(data) {
  return request.post('/goods/delete', data)
}

export function setStatusOfGoods(data) {
  return request.post('/goods/up-down-shelf', data)
}

export function deletePicOfGoods(data) {
  return request.post('/goods/delete-pic', data)
}

export function historyPriceOfGoods(data) {
  return request.post('/goods/history-price', data)
}



// WEBPACK FOOTER //
// ./src/api/goods/info.js